// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__Q8jl7","info_text":"styles_info_text__3QNRH"};